import {object} from 'prop-types';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toggleCollectionVisibility} from '@app/actions/collections';
import {trackEvent} from '@app/analytics';
import {getHashFromId} from '@app/util/granero';
import VisibilityButton from '@components/common/VisibilityButton';

const ToggleVisibilityButton = ({collection, ...props}) => {
  const dispatch = useDispatch();
  const collectionHashId = getHashFromId(collection.id);

  const isVisible = useSelector(state =>
    state.collections.visibleIds.includes(collectionHashId)
  );

  const onClick = () => {
    trackEvent('Collection Toolbar', {
      action: 'Toggled Visibility',
      isVisible,
      collectionId: collection.id,
    });
    dispatch(toggleCollectionVisibility(collection));
  };
  return (
    <VisibilityButton
      isVisible={isVisible}
      onClick={onClick}
      tooltipText="Toggle view"
      {...props}
    />
  );
};

ToggleVisibilityButton.propTypes = {
  collection: object.isRequired,
};

export default ToggleVisibilityButton;
